// extracted by mini-css-extract-plugin
export default {"item":"sCXlNvfO","itemTitle":"KXBfFP43","itemProperty":"DMNdMWUf","cardWrapper":"a5nKo3eG","removeButton":"bKv5d1nN"};